/*
 * @Author: wuzhimin14 wuzhimin14@jd.com
 * @Date: 2023-11-15 14:26:33
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2024-04-10 16:08:29
 * @FilePath: /jdi-web-inter/src/components/FourCategorySelect/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Select } from 'antd';
import styles from './index.module.scss';
import { getAddressItemList } from '@/api/newApi/personalCenter/address';
import { useTranslation } from 'react-i18next';
const { Item } = Form;

interface ProvinceCityCascaderIndexProps {
  detailData:any;
  disabled?: boolean; //是否禁选
  formRef?: any;
  initialValue?: any;
  required?: boolean;
  param?: any; //额外参数
  handleChange?: (level: string, levelId: string) => void;
}

const ProvinceCityCascaderIndex: React.FC<ProvinceCityCascaderIndexProps> = (props: any) => {
  const { initialValue, param = {}, detailData, required, formRef, disabled, handleChange } = props;
  const [defaultRequired, setDefaultRequired] = useState(true);
  const [countryList, setCountryList] = useState<any[]>([]);
  const [provinceList, setProvinceList] = useState<any[]>([]);
  const [cityList, setCityList] = useState<any[]>([]);
  const [countyList, setCountyList] = useState<any[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<any>(detailData.countryId || '');
  const [selectedProvince, setSelectedProvince] = useState<any>(detailData.provinceId || '');
  const [selectedCity, setSelectedCity] = useState<any>(detailData.cityId || '');
  const [selectedCounty, setSelectedCounty] = useState<any>(detailData.countyId || '');

  const { t } = useTranslation();

  //
  /**
   * 获取级联地址列表
   * param parentId 上层选中id type 国省市区
  */
  const getAllList = async (parentId: number, type?:string) => {
    const res: any = await getAddressItemList({ parentId });
    if (res.success) {
      const newData = res?.value?.map((item: any) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      if(type == '1'){
        setProvinceList(newData);
      }else if(type == '2'){
        setCityList(newData);
      }else if(type == '3'){
        setCountyList(newData);
      } else{
        setCountryList(newData);
      }
      return newData;
    } else {
      // Clear corresponding lists if the API call fails or returns no data
      if(type == '1'){ setProvinceList([]); }
      else if(type == '2'){ setCityList([]); }
      else if(type == '3'){ setCountyList([]); }
      else { setCountryList([]); }
      return [];
    }
  };
  
  useEffect(() => {
    const initializeAddressData = async () => {
      // 1. Always fetch the base country list first
      await getAllList(-1, '0'); // This populates countryList

      if (detailData && detailData.address) {
        const { countryId, provinceId, cityId, countyId } = detailData.address;
        const formValuesToSet: any = { countryId: null, provinceId: null, cityId: null, countyId: null, countryArea: null };

        if (countryId) {
          setSelectedCountry(countryId);
          await getAllList(countryId, '1'); // Load provinces
          formValuesToSet.countryId = countryId;
          formValuesToSet.countryArea = countryId; // for validation
        } else {
          // If no countryId from detailData, clear all downstream states and form fields
          setSelectedCountry(''); setProvinceList([]);
          setSelectedProvince(''); setCityList([]);
          setSelectedCity(''); setCountyList([]);
          setSelectedCounty('');
          formRef?.setFieldsValue(formValuesToSet); // Clears all to null
          return;
        }

        if (provinceId) {
          setSelectedProvince(provinceId);
          await getAllList(provinceId, '2'); // Load cities
          formValuesToSet.provinceId = provinceId;
        } else {
          setSelectedProvince(''); setCityList([]);
          setSelectedCity(''); setCountyList([]);
          setSelectedCounty('');
          // Clear only downstream form values, keep country
          formRef?.setFieldsValue({ ...formValuesToSet, provinceId: null, cityId: null, countyId: null });
          return;
        }

        if (cityId) {
          setSelectedCity(cityId);
          await getAllList(cityId, '3'); // Load counties
          formValuesToSet.cityId = cityId;
        } else {
          setSelectedCity(''); setCountyList([]);
          setSelectedCounty('');
          // Clear only downstream form values, keep country & province
          formRef?.setFieldsValue({ ...formValuesToSet, cityId: null, countyId: null });
          return;
        }

        if (countyId) {
          setSelectedCounty(countyId);
          formValuesToSet.countyId = countyId;
        } else {
          setSelectedCounty('');
          // Clear only county form value
          formValuesToSet.countyId = null;
        }
        
        formRef?.setFieldsValue(formValuesToSet);
        if (formValuesToSet.countryArea) { // Validate if country was set
            formRef?.validateFields(['countryArea']);
        }

      } else {
        // No detailData or no detailData.address, clear all states and form fields
        setSelectedCountry(''); setProvinceList([]);
        setSelectedProvince(''); setCityList([]);
        setSelectedCity(''); setCountyList([]);
        setSelectedCounty('');
        formRef?.setFieldsValue({ countryId: null, provinceId: null, cityId: null, countyId: null, countryArea: null });
      }
    };

    initializeAddressData();
  }, [detailData, formRef]); // Rerun if detailData or formRef changes

  // These useEffects handle user interaction AFTER initial load
  useEffect(() => {
    if(selectedCountry) {
      // Only fetch if it's not part of the initial load triggered by detailData directly,
      // or if selectedCountry changes due to user interaction.
      // The initial load sequence already calls getAllList for provinces.
      // This check might be redundant if initial load sets selectedCountry correctly
      // and this effect is mainly for user changes.
      // For simplicity, we can let it run, getAllList is idempotent for the same parentId.
      getAllList(selectedCountry, '1');
    }
  }, [selectedCountry]);

  useEffect(() => {
    if(selectedProvince) {
      getAllList(selectedProvince, '2');
    }
  }, [selectedProvince]);

  useEffect(() => {
    if(selectedCity) {
      getAllList(selectedCity, '3');
    }
  }, [selectedCity]);

  return (
    <div className={styles.index}>
      <Item label={TLT(`请选择地址`)} name="countryArea" rules={[{
        required:true,
        message:TLT(`请选择地址`)
      }]}>
        <Row gutter={12} >
          <Col span={6}>
            <Item name={'countryId'} className={styles.itemStyle} rules={[{ required: true, message: TLT(`请选择国家`) }]}>
              <Select
                options={countryList}
                placeholder={TLT(`请选择国家`)}
                onChange={(value: any) => {
                  setSelectedCountry(value);
                  setSelectedProvince('');
                  setSelectedCity('');
                  setSelectedCounty('');
                  setProvinceList([]);
                  setCityList([]);
                  setCountyList([]);
                  formRef?.setFieldsValue({
                    provinceId: null,
                    cityId: null,
                    countyId: null,
                    countryArea: value // 当国家选择后，countryArea才算有值
                  });
                  formRef?.validateFields(['countryArea']);
                }}
              />
            </Item>
          </Col>
          <Col span={6}>
            <Item name={'provinceId'} className={styles.itemStyle} rules={[{ required: true, message: TLT(`请选择省份`)}]}>
              <Select
                options={provinceList}
                placeholder={TLT(`请选择省份`)}
                onChange={(value: any) => {
                  setSelectedProvince(value);
                  setSelectedCity('');
                  setSelectedCounty('');
                  setCityList([]);
                  setCountyList([]);
                  formRef?.setFieldsValue({
                    cityId: null,
                    countyId: null,
                  });
                }}
              />
            </Item>
          </Col>
          <Col span={6}>
            <Item name={'cityId'} className={styles.itemStyle} rules={[{ required: true, message: TLT(`请选择城市`) }]}>
              <Select
                options={cityList}
                placeholder={TLT(`请选择城市`)}
                onChange={(value: any) => {
                  setSelectedCity(value);
                  setSelectedCounty('');
                  setCountyList([]);
                  formRef?.setFieldsValue({
                    countyId: null,
                  });
                }}
              />
            </Item>
          </Col>
          <Col span={6}>
            <Item name={'countyId'} className={styles.itemStyle} rules={[{ required: true, message: TLT(`请选择区`) }]}>
              <Select
                  options={countyList}
                  placeholder={TLT(`请选择区`)}
                  onChange={(value: any) => {
                    setSelectedCounty(value); // 更新区/县的选中状态
                    formRef?.setFieldsValue({
                      countryArea:selectedCountry // 确保在选择区/县后，整体地址校验字段有值
                    });
                    formRef?.validateFields(['countryArea']);
                  }}
              />
            </Item>
          </Col>
        </Row>
      </Item>
    </div>
  );
};

export default ProvinceCityCascaderIndex;

